<template>
  <div :class="$style['g-head']">
    <div class="m-container" :class="$style['m-container']">
      <div :class="$style['container-inner']" class="flex justify-between">
        <div
          :class="$style['state--pos-left']"
          class="flex justify-start items-center"
        >
          <a :class="$style['nav-logo']" class="flex items-center" href="/">
            <!-- <img
                            :class="$style['logo-img']"
                            :src="publicPath + 'images/logo.png'"
                            alt="superex"
                        /> -->
            <img
              :class="$style['logo-img']"
              src="../../assets/images/newLogoV3.png"
              alt="superex"
            />
          </a>
        </div>
        <div
          :class="$style['state--pos-right']"
          class="flex justify-end items-center"
        >
          <div :class="$style['btn-group--text']" class="grid">
            <div v-if="!token">
                <button
                    v-for="item in textBtns"
                    :key="item.type"
                    :class="$style['btn-item']"
                    class="flex justify-center items-center"
                    :data-type="item.type"
                    @click="toRegister"
                >
                    <span :class="$style['text']">
                        <!-- {{ item.text }} -->
                        {{$t('300041')}}
                    </span>
                </button>
            </div>
            <div v-else>
                <button
                    v-for="item in textBtns"
                    :key="item.type"
                    :class="$style['btn-item']"
                    class="flex justify-center items-center"
                    :data-type="item.type"
                    @click="$router.push({path:'/download'})"
                >
                    <span :class="$style['text']">
                        <!-- {{ item.text }} -->
                        {{$t('300332')}}
                    </span>
                </button>
            </div>
          </div>
          <div
            class="open btn-open-lang"
            :class="$style['btn--open-fold-nav']"
            @click="showLanguageSwitch = true"
          >
            <div :class="$style['btn--inner']">
              <div :class="$style['line']"></div>
              <div :class="$style['line']"></div>
              <div :class="$style['line']"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition
      :css="false"
      @before-enter="beforeEnter"
      @enter="enter"
      @leave="leave"
    >
      <!-- <SiteNavFold v-if="foldNavIsOpen" :class="$style['site-nav--fold']" :nav-list="siteNavList" :open="foldNavIsOpen" @closeFoldNav="foldNavIsOpen = false" /> -->
      <div v-show="showLanguageSwitch" :class="$style['inner']" class="olololol">
        <div :class="$style['lang-switch-head']" class="nnnn">
          <button
            :class="$style['btn--close-fold-nav']"
            class="flex justify-center items-center"
            @click="closeLangModal"
          >
            <UeIcon :class="$style['ic']" name="x-close" />
          </button>
        </div>
        <!-- <transition
        :css="false"
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
      > -->
        <LanguageSwitch
          ref="LanguageSwitch"
          @closeLangModal="closeLangModal"
          :isShow="showLanguageSwitch"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import mitt from "mitt";
import { languageArr, languageName } from "@/utils/utilsType";
import { setCookie, getCookie } from "@/utils/auth";
import { gsap } from "../../utils/gsap";
import LanguageSwitch from "./LanguageSwitch.vue";
import { handleTest } from "@/utils";
// import { gsap } from "@stone/uemo-utils/utils/gsap";
import _throttle from "lodash/throttle";
import { mapGetters } from 'vuex'
// import SiteNavFold from "@/components/SiteNavFold.vue";

export default {
  data() {
    return {
      mittManage: mitt(),
      publicPath: process.env.PUBLIC_PATH,
      siteNavList: [
        { title: "P2P", link: "" }
        // ... 其他数据
      ],
      textBtns: [{ type: "register", text: "Register" }],
      foldNavIsOpen: false,
      showLanguageSwitch: false
    };
  },
  components: {
    LanguageSwitch
    // SiteNavFold
  },
  computed: {
        ...mapGetters(['isDirection', 'token','user']),
    },
  created() {
    this.change_language();
    // window.document.documentElement.setAttribute(
    //         'dir',
    //         this.isDirection ? 'rtl' : 'ltr'
    //     )
  },
  mounted() {
    this.checkPageScroll();
    const _throttleWatch = _throttle(this.checkPageScroll, 100);
    document.getElementById("gBody").addEventListener("scroll", _throttleWatch);
    this.mittManage.on("destroy", () => {
      document.body.removeAttribute("data-has-scroll");
      document
        .getElementById("gBody")
        .removeEventListener("scroll", _throttleWatch);
    });
  },
  watch: {},
  methods: {
    toRegister(){
      this.$store.dispatch('setTrigger','public_register_button')
      this.$router.push({path:'/register'})
    },
    change_language(curtLang) {
      let paramsName = this.$route.query.language;
      let inviteCode = this.$route.query.invitationCode;
      const language = getCookie("language") || "en";
      if (paramsName != language) {
        if (languageArr.indexOf(paramsName) !== -1) {
          setCookie("language", paramsName);
          this.$store.dispatch("setLanguageName", languageName[paramsName]);
          setCookie("languageName", languageName[paramsName]);
          document.documentElement.setAttribute("language", paramsName);
          setTimeout(() => {
            this.$i18n.locale = paramsName;
          }, 500);
          // inviteCode
          if (!inviteCode) {
            this.$router.replace(`/newIndex?language=${paramsName}`);
          } else {
            this.$router.replace(
              `/newIndex?invitationCode=${inviteCode}&&language=${paramsName}`
            );
          }
        } else {
          // TODO inviteCode 相关代码
          // if (!inviteCode) {
          //   this.$router.replace(`/newIndex?language=${language}`);
          // } else {
          //   this.$router.replace(
          //     `/newIndex?invitationCode=${inviteCode}&&language=${language}`
          //   );
          // }
        }
      }
    },
    checkPageScroll() {
      console.log("进了吗");
      const scrollTop = document.getElementById("gBody").scrollTop || 0;
      const hasScroll = scrollTop > 0;
      document.body.setAttribute("data-has-scroll", hasScroll ? "1" : "0");
    },
    beforeEnter(el) {
      gsap.set(el, { opacity: "0" });
    },
    enter(el, done) {
      console.log("进入了");
      gsap.to(el, {
        opacity: "1",
        duration: 0.36,
        onComplete: done
      });
    },
    leave(el, done) {
      console.log("移出了");
      gsap.to(el, {
        opacity: "0",
        duration: 0.16,
        onComplete: done
      });
    },
    closeLangModal() {
      this.showLanguageSwitch = false;
    }
  }
  // beforeDestroy() {
  //     this.mittManage.emit("destroy");
  //     this.mittManage.all.clear();
  // }
};
</script>
<style lang="scss" scoped>
//正常
[dir='ltr'] {
    .btn-open-lang{
        margin-left: 35px;
    }
}
//波斯
[dir='rtl'] {
    .btn-open-lang{
        margin-right: 35px;
    }
}
</style>
<style lang="scss" module>
//new
// @import "../../assets/newCss/var.scss";
// @import "../../assets/newCss/base.scss";
// @import "../../assets/newCss/reset.scss";
// @import "../../assets/uemo-icon-font/fonts/ueicon.css";
// @import "../../assets/tailwendcss.css";


@import "../../assets/uemo-scss/scss/abstracts/_mixins.scss";

body[data-has-scroll="1"] {
  .g-head {
    .m-container {
      padding-top: 20px;

      background: rgba(28, 28, 28, 0.4);

      backdrop-filter: blur(25px);
    }
  }
}
.m-container {
  width: var(--g--container-width);
  max-width: 100%;
  margin: 0 auto;
  padding: 0 var(--g--container-space);
  background: rgba(28,28,28,0.4);
  backdrop-filter: blur(50px);
}
.g-head {
  position: sticky;
  z-index: var(--g--layer--z-index--lv1);
  top: 0;
  left: 0;
  .m-container {
    padding-top: 50px;
    padding-bottom: 20px;

    transition: 0.36s ease;
  }
  .container-inner {
    position: relative;
  }
  .nav-logo {
    .logo-img {
      height: 48px;
    }
  }
  .btn-group--text {
    font-size: 24px;
    // line-height: 1.8px;
    gap: 8px;
    grid-auto-flow: column;
    .btn-item {
      position: relative;

      padding: 8px 18px;

      border: 2px solid transparent;
      &[data-type="register"] {
        // border-color: color(var(--g--color-theme--main));
        color: rgb(255, 255, 255);
        // border-color: rgb(239, 146, 0);
        border-color: #FFC72B;
        border-radius: 100px;
        background-color: transparent;
      }
    }
  }
  .btn-group--icon {
    font-size: 20px;

    margin-left: 18px;

    color: color(var(--g--color-font--default), 0.3);

    gap: 15px;
    .btn-item {
      @include circle(32px);
      position: relative;

      transition: 0.26s ease;
      &[data-active],
      &:hover {
        color: color(var(--g--color-font--default));
        background-color: rgba(#fff, 0.1);
      }
      &[data-type="downloadApp"]:hover {
        .download-info {
          visibility: visible;

          padding-top: 10px;

          pointer-events: initial;

          opacity: 1;
        }
      }
    }
    .download-info {
      font-size: 12px;

      position: absolute;
      top: 100%;
      right: -50px;

      visibility: hidden;

      padding-top: 20px;

      transition: 0.26s ease;
      pointer-events: none;

      opacity: 0;
      .inner {
        padding: 18px 18px 13px;

        border-radius: 6px;
        background-color: #fff;
      }
      .title {
        margin-top: 5px;
        padding: 5px 0;

        text-align: center;

        color: color(var(--g--color-font--reverse));
        border-bottom: 1px solid rgba(#000, 0.1);
      }
      .code-box {
        @include image-placeholder-v4(130, 130);
        width: 130px;
      }
      .download-btn {
        display: block;

        margin-top: 10px;
        padding: 8px 6px;

        color: #fff;
        border-radius: 4px;
        // background-color: color(var(--g--color-theme--main));
        background-color: #FFC72B;
      }
    }
  }
  .btn--open-fold-nav {
    @include square(54px);
    position: relative;

    display: flex;

    // margin-left: 35px;

    cursor: pointer;

    align-items: center;
    justify-content: center;
    .btn--inner {
      position: relative;

      width: 44px;
      height: 5px;

      pointer-events: none;
    }
    &:hover {
      .line {
        background-position: 0%;
      }
    }
    &[data-is-open] {
      .site-nav--fold {
        --nav-fold--inner-y: 0;
        --opacity: 1;
        visibility: visible;
      }
    }
    .line {
      position: absolute;
      left: 0;

      overflow: hidden;

      width: 100%;
      height: 100%;

      transition: 0.36s ease;
      transition-delay: calc(var(--delay) * 0.1s);

      border-radius: 4px;
      background-color: rgba(#fff, 0.6);
      background-position: 100%;
      background-size: 200% 100%;
      &:first-child {
        top: -13px;
      }
      &:nth-child(2) {
        top: 0;
      }
      &:last-child {
        bottom: -13px;
      }
    }
  }
}
.site-nav--fold {
  position: fixed;
  z-index: calc(var(--g--layer--z-index--lv1) + 10);
  top: 0;
  left: 0;
}
// .inner {
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   width: 100%;
//   height: var(--g--full-height);
//   background: rgb(22, 23, 25 / 0.8);
//   box-shadow: 0 4px 6px -2px rgb(16, 24, 40 / 0.03),
//     0 12px 16px -4px rgb(16, 24, 40 / 0.08);
//   backdrop-filter: blur(25px);
// }
.inner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  bottom: 0;
  right: 0;
//   height: 100%;
//   width: 100%;
//   height: var(--g--full-height);
  background: rgb(22, 23, 25 / 0.8);
  box-shadow: 0 4px 6px -2px rgb(16, 24, 40 / 0.03),
    0 12px 16px -4px rgb(16, 24, 40 / 0.08);
  backdrop-filter: blur(25px);
}
.lang-switch-head {
  height: 158px;
}
.btn--close-fold-nav {
  @include square(50px);
  font-size: 45px;
  position: absolute;
  z-index: var(--g--z-index);
  color: #fff;
  top: 50px;
  right: 30px;
  transition: 0.36s ease;
  transform: translateY(var(--nav-fold--inner-y));
}
</style>



// WEBPACK FOOTER //
// src/compontents/newHome/SiteHead.vue